import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import AddressValidation from '../../components/address-validation';
import style from './address-validation.module.less';
import { emptyObject } from 'ui-components/default-props/empty';

const AddressValidationSection = ({ validateAddress = noop, shipToAddress = emptyObject }) => {
  return (
    <div className={style['validate-links']}>
      <AddressValidation
        countryCode={shipToAddress.countryCode}
        residentialIndicator={shipToAddress.residentialIndicator}
        validateAddress={validateAddress}
        validation={shipToAddress.verificationStatus}
        validationMessage={shipToAddress.verificationMessage}
      />
    </div>
  );
};

AddressValidationSection.propTypes = {
  validateAddress: PropTypes.func,
  shipToAddress: PropTypes.object,
};

export default AddressValidationSection;
